<template>
  <div
    :style="{ 'background-image': `url(${url ? url : avatarPlaceholder})` }"
    class="avatar"
  >
    <span v-if="name" class="sr-only">
      {{ name }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: require("@/assets/media/avatars/avatar9.jpg")
    },
    name: {
      type: String,
      default: null
    }
  },
  data: () => ({
    avatarPlaceholder: require("@/assets/media/avatars/avatar0.jpg")
  })
};
</script>

<style lang="scss" scoped>
.avatar {
  background-color: $gray;
  background-size: cover;
}
</style>
